import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initWebVitals } from './utils/webVitals';
import { initSmartPrefetch } from './utils/smartPrefetch';
import { Capacitor } from '@capacitor/core';

// Détecte si on est sur une plateforme native
const IS_NATIVE = Capacitor.isNativePlatform();

// Désactive les logs verbeux en production (garde warn/error pour le diagnostic)
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}


// Gestion globale des erreurs
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });
  return false;
};

window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

// Initialiser le monitoring des Web Vitals (seulement sur web)
if (!IS_NATIVE) {
  initWebVitals();
}

// Initialiser le préchargement intelligent
initSmartPrefetch();

// Enregistrer le Service Worker uniquement pour le web (pas sur native)
if (!IS_NATIVE) {
  serviceWorkerRegistration.register({
    onSuccess: () => {
    },
    onUpdate: (registration) => {
    }
  });
} else {
  // Sur native, désactiver le service worker
  serviceWorkerRegistration.unregister();
}
